import React from 'react';
import ReactDOM from 'react-dom';
import 'index.css';
import App from 'app/App';
import './styles.css';
import 'react-app-polyfill/ie9';

ReactDOM.render(<App />, document.getElementById('root'));
